import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["panel", "backdrop"];

  toggle() {
    if (this.panelTarget.classList.contains("translate-x-full")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.panelTarget.classList.remove("translate-x-full");
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none");
    this.backdropTarget.classList.add("opacity-100", "pointer-events-auto");
  }

  close() {
    this.panelTarget.classList.add("translate-x-full");
    this.backdropTarget.classList.remove("opacity-100", "pointer-events-auto");
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none");
  }
}
